import React, { useRef } from "react";
import { ImageUp } from "lucide-react";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";

export const AdminImageUploadField = ({ wrapperTestId, label, inputId, inputTestId, uploadButtonTestId, previewTestId, previewImageTestId, imageUrl, previewAlt, onChange, onFileSelected, isUploading, fallbackText }) => {
  const fileInputRef = useRef(null);

  return (
    <div className="space-y-3" data-testid={wrapperTestId}>
      <div className="space-y-2">
        <Label htmlFor={inputId}>{label}</Label>
        <Input data-testid={inputTestId} id={inputId} onChange={(event) => onChange(event.target.value)} value={imageUrl} />
      </div>
      <input
        accept="image/jpeg,image/png,image/webp,image/gif"
        className="hidden"
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) onFileSelected(file);
          event.target.value = "";
        }}
        ref={fileInputRef}
        type="file"
      />
      <Button className="rounded-full bg-[#0f766e] text-white hover:bg-[#149289]" data-testid={uploadButtonTestId} disabled={isUploading} onClick={() => fileInputRef.current?.click()} type="button">
        <ImageUp className="mr-2 h-4 w-4" />
        {isUploading ? "Upload..." : "Uploader une image"}
      </Button>
      <div className="overflow-hidden rounded-[1.4rem] border border-[#d8ece4] bg-[#f8fcf3]" data-testid={previewTestId}>
        {imageUrl ? (
          <img alt={previewAlt} className="h-52 w-full object-contain bg-white" data-testid={previewImageTestId} src={imageUrl} />
        ) : (
          <div className="flex h-40 items-center justify-center px-6 text-center text-sm text-slate-500">{fallbackText}</div>
        )}
      </div>
    </div>
  );
};